/**
 * SHER-759. The VPA decision is a field of the VPA form, of this type. The API migration
 * adds it to every survey typed VPA, and the save hook reads its answer to move the
 * surgical request (sherwood-api `src/utils/vpaFormOutcome.ts`).
 */
export const VPA_OUTCOME_FIELD_TYPE = 'vpa_outcome';

/**
 * The answers, in the order the field offers them. The wording is the waiting list's own
 * status labels, so the form, its PDF and the surgical list say the same thing.
 */
export const VPA_OUTCOME_OPTIONS = [
    { value: 'none', labelId: 'hospital.vpa-form-outcome.none' },
    { value: 'accepted', labelId: 'pages.hospital.services.request_status.ANESTHESIOLOGIST_ACCEPTED' },
    { value: 'rejected', labelId: 'pages.hospital.services.request_status.ANESTHESIOLOGIST_REJECTED' },
] as const;

export type VpaOutcomeValue = typeof VPA_OUTCOME_OPTIONS[number]['value'];

function findVpaOption(stored: unknown) {
    return VPA_OUTCOME_OPTIONS.find((option) => option.value === stored) ?? null;
}

/** A saved answer, or null when there is none. */
export function parseVpaOutcome(stored: unknown): VpaOutcomeValue | null {
    return findVpaOption(stored)?.value ?? null;
}

/** The translation id that words a saved answer, or null when there is none. */
export function vpaOutcomeLabelId(stored: unknown): string | null {
    return findVpaOption(stored)?.labelId ?? null;
}
